// Login.jsx - Estate Experts Login Page
import React, { useContext, useEffect, useState } from 'react';
import {
  FiMail,
  FiLock,
  FiEye,
  FiEyeOff,
  FiArrowRight
} from 'react-icons/fi';
import { BsBuilding } from 'react-icons/bs';
import '../../../assets/css/admin/dashboard/adminlogin/login.css';
import logo2 from "../../../assets/images/logo2.png";
import { User } from 'lucide-react';
import axios from 'axios';
import AppContext from 'context/AppContext';
import { Spinner } from 'react-bootstrap';


const AuthLogin = () => {

  const { baseUrl, Navigate, regExpChecker, setAuthToken, setLoggedInAdmin } = useContext(AppContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [loginLoading, setLoginLoading] = useState(false);
  const [errors, setErrors] = useState("");
  const [pageLoading, setPageLoading] = useState(true);

  const togglePasswordVisibility = () => {
    setPassword(!password);
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!rememberMe) {
      setErrors("Please check Remember Me before logging in.");
      return;
    }

    setErrors("");
    setLoginLoading(true);
    adminLogin();
  };
  const handleSocialLogin = (provider) => {
    alert(`${provider} login coming soon!`)
  };
  const adminLogin = () => {
    const formData = new FormData();
    formData.append("email", email);
    formData.append("password", password);
    axios.post(`${baseUrl}/admin/auth/login`, formData)
      .then((response) => {
        console.log(response.data);
        if (response.data.admin == null) {
          setLoginLoading(false);
          setErrors("Invalid email or password"); // ❌ wrong login
        } else {
          setLoginLoading(false);
          localStorage.setItem("authToken", response.data.token);
          setAuthToken(response.data.token);
          localStorage.setItem("adminemail", email);
          localStorage.setItem("adminpassword", password)
          localStorage.setItem("loggedInAdmin", JSON.stringify(response.data.admin));
          setLoggedInAdmin(response.data.admin);
          Navigate("/admin/dashboard"); // ✅ correct login
        }
      })
      .catch((error) => {
        setLoginLoading(false);
        console.error(error);
      });
  }

  const adminAlLogin = (alEmail, alPassword) => {
    setLoginLoading(true);

    let formData = new FormData();
    formData.append("email", alEmail);
    formData.append("password", alPassword);
    axios
      .post(`${baseUrl}/admin/auth/login`, formData)
      .then((response) => {
        console.log(response.data);
        if (response.data.admin != null) {
          setLoginLoading(false);
          localStorage.setItem("authToken", response.data.token);
          setAuthToken(response.data.token)
          setErrors("Invalid email or password"); // ❌ wrong login
        } else {
          setLoginLoading(false);
          Navigate("/admin/dashboard"); // ✅ correct login
        }
      })
      .catch((error) => {
        setLoginLoading(false);
        console.error(error);
      });
  };

  useEffect(() => {
    const email = localStorage.getItem("adminemail");
    const password = localStorage.getItem("adminPassword");
    console.log(email);
    console.log(password);
    if (email != null && email != "") {
      adminAlLogin(email, password);
    } else {
      setPageLoading(false);
    }
  }, []);
  const handleForgotPassword = () => {
    Navigate('/forgot-password');
  };


  const handleSignUp = () => {
    Navigate('/signup');
  };

  return pageLoading == true ? (
    <div
      style={{ height: "100vh" }}
      className="d-flex justify-content-center align-items-center"
    >
      <Spinner style={{ height: 80, width: 80, fontSize: 60 }} />
    </div>
  ) : (
    <div className="admin-login-page">

      {/* Login Container */}
      <div className="admin-login-container">
        <div className="admin-login-card">
          {/* Logo Section */}
          <div className="admin-login-logo">
            {/* <div className="admin-logo-icon-login"> */}
            <img
              src={logo2}
              alt="Estate Experts"
              className="navbar-logo"
            />
            {/* </div> */}
            <h2 className="admin-company-name">ESTATE EXPERTS</h2>
          </div>

          {/* Welcome Text */}
          <div className="admin-login-header">
            <h1 className="admin-login-title">Welcome Back</h1>
            <p className="admin-login-subtitle">Log in to your account to continue</p>
          </div>
          {errors && (
            <div className='auth-seterrors'>
              {errors}
            </div>
          )}

          {/* Login Form */}
          <form onSubmit={handleSubmit} className="admin-login-form">

            {/* Email Field */}
            <div className="admin-form-group">
              <label className="admin-form-label">Email Address</label>
              <div className={`admin-input-wrapper ${errors.email ? 'error' : ''} ${email ? 'filled' : ''}`}>
                <FiMail className="admin-input-icon" />
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)
                  }
                  placeholder="example@email.com"
                  className="form-input"
                />
              </div>
              {errors.email && (
                <span className="admin-error-message">{errors.email}</span>
              )}
            </div>

            {/* Password Field */}
            <div className="admin-form-group">
              <label className="admin-form-label">Password</label>
              <div className={`admin-input-wrapper ${errors.password ? 'error' : ''} ${password ? 'filled' : ''}`}>
                <FiLock className="admin-input-icon" />
                <input
                  type={password ? 'text' : 'password'}
                  name="password"
                  value={password}
                  onChange={(event) => setPassword(event.target.value)
                  }
                  placeholder="••••••••"
                  className="form-input"
                />
                <button
                  type="button"
                  className="admin-password-toggle"
                  onClick={() => setPassword(!password)}
                >
                  {password ? <FiEyeOff /> : <FiEye />}
                </button>
              </div>
              {errors.password && (
                <span className="admin-error-message">{errors.password}</span>
              )}
            </div>

            {/* Remember Me & Forgot Password */}
            <div className="admin-form-options">
              <label className="admin-checkbox-label">
                <input
                  type="checkbox"
                  name="rememberMe"
                  checked={rememberMe}
                  onChange={(event) => setRememberMe(event.target.checked)}
                  className="admin-checkbox-input"
                />

                <span className="admin-checkbox-custom"></span>

                <span className="admin-checkbox-text">
                  Remember me
                </span>
              </label>
            </div>
            {/* Submit Button */}
            <button
              type="submit"
              className={`admin-submit-btn ${loginLoading ? 'loading' : ''}`}
              disabled={loginLoading}
            >
              {loginLoading ? (
                <>
                  <span className="admin-spinner"></span>
                  <span>Loging In...</span>
                </>
              ) : (
                <>
                  <span>Log In</span>
                  <FiArrowRight className="admin-submit-icon" />
                </>
              )}
            </button>
          </form>
        </div>
        {/* Decorative Elements */}
        <div className="admin-floating-element element-1">
          <BsBuilding />
        </div>
        <div className="admin-floating-element element-2">
          <BsBuilding />
        </div>
      </div>
    </div>
  );
};

export default AuthLogin;